import PubSub from 'pubsub-js';

const header = {
  $header: document.getElementById('main_header'),
  init() {
    console.log('Header init');

    this.setUpListeners();
  },

  setUpListeners() {
  }
};


export default header;
